import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'tt-hint, [ttHint]',
  standalone: true,
})
export class FormFieldHintDirective {
  @HostBinding('class.tt-hint') hintClass = true;
}
